import { Component, Input } from '@angular/core';

@Component({
    selector: 'donate-banner',
    styleUrls: ['./donate-banner.component.scss'],
    template: `
        <div class="banner">
            {{ balance | currency:'USD':true:'1.0-0' }} still needed for this project
        </div>
    `    
})
export class DonateBannerComponent {
    @Input() balance: number;
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/components/donate-banner.component.ts